import { render, staticRenderFns } from "./DatamapFileSelector.vue?vue&type=template&id=126177a3&scoped=true&"
import script from "./DatamapFileSelector.vue?vue&type=script&lang=js&"
export * from "./DatamapFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./DatamapFileSelector.vue?vue&type=style&index=0&id=126177a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126177a3",
  null
  
)

export default component.exports